/**
 * useValidateTransactionComplete()
 *
 * Validates transaction is complete
 * If not, log an error and navigate to the index page
 *
 * Used by the success steps of donate journeys
 * ...to prevent them being accessed until a transaction is complete
 */
import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/store/hooks';
import { logger } from '@/services/logger/logger';

export function useValidateTransactionComplete() {
  // Takes value from state once (on load), do not re-render on state change (using `() => true` equality check as second argument)
  const completeState = useAppSelector(state => state.transaction.complete, () => true);

  const navigate = useNavigate();

  useEffect(() => {
    // If transaction is complete (as expected), do nothing
    if (completeState) {
      return;
    }

    logger.error('Page inaccessible. Transaction is not yet complete.');
    void navigate('/');
  }, [completeState, navigate]);
}
